<div class="collection-container flex-col">
    <div class="status-container" *ngIf="collection.length > 8">
        <div class="status" *ngFor="let status of availableStatus"
            [ngClass]="['color-' + status.color, (status.status === null || status.status === activeStatus) ? 'active' : '']"
            (click)="statusSelection(status.status)">
            {{status.name | lang | uppercase}}: {{status.value}}
        </div>
    </div>

    <div #statusFront>
        <div *ngIf="!visibleData" class="no-data">
            <div class="img" *ngIf="!isLoading">
                <img appImageSelector alt="mt-image" [imageType]="'icon'" [imageKey]="'error'">
            </div>

            <div class="load rotating" *ngIf="isLoading">
                <img src="../../../../../../assets/img/icon/loader.png" alt="loader">
            </div>

            <div class="message">
                <span *ngIf="!isLoading && collection.length">{{'m020' | lang}}</span>
                <span *ngIf="!isLoading && !collection.length">{{'m019' | lang}}</span>
                <span *ngIf="isLoading">{{'wait_while_data_loading' | lang}}</span>
            </div>
        </div>
    </div>
</div>